import { useSelector } from "react-redux";

import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import CreateNewFolderOutlinedIcon from "@mui/icons-material/CreateNewFolderOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import FileOpenOutlinedIcon from "@mui/icons-material/FileOpenOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import FolderOffOutlinedIcon from "@mui/icons-material/FolderOffOutlined";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import NoteAddOutlinedIcon from "@mui/icons-material/NoteAddOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import TroubleshootOutlinedIcon from "@mui/icons-material/TroubleshootOutlined";

import { fetchProject, setProjectAttrsVisible } from "slices/project_work";
import {
	getAdvSearchVisible,
	saveProjectVisible,
	setAdvSearchVisible,
	setOnlyMyProject,
	setProjectReportVisible,
	setShareProjectVisible,
	setViewParamsKeyValue,
} from "slices/projects";
import { getUserSettingsLsrStatus } from "slices/user_adv";

const ProjectsRibbonSettings = ({
	addNewProject,
	addNewProjectPack,
	addNewProjectToPack,
	showDeleteDialog,
	enterToProject,
	enterToProjectImport,
	enterToLsrEditor,
	getProjectXlsx,
	getProjectProtocol,
	enableEditingMode,
	getProjectXmlZip,
	dispatch,
	getTableData,
	setProjectsViewLsSettings,
}) => {
	const userPermissions = useSelector((state) => state.auth.permissions);
	const clickedTableRow = useSelector((state) => state.ribbon.clickedTableRow);
	const muiltiClickedTableRows = useSelector((state) => state.ribbon.muiltiClickedTableRows);
	const onlyMyProject = useSelector((state) => state.projects.table.viewParams.onlyMyProject);
	const alwaysShowFolderContent = useSelector((state) => state.projects.table.viewParams.alwaysShowFolderContent);
	const advSearchVisible = useSelector(getAdvSearchVisible);
	const lsrStatusUsage = useSelector(getUserSettingsLsrStatus);

	return [
		{
			name: "Действия",
			_children: [
				{
					orientation: "horizontal",
					_children: [
						{
							name: "Создать проект",
							icon: <AddBoxOutlinedIcon />,
							size: "large",
							type: "common",
							callback: () => {
								if (clickedTableRow?.id != null && clickedTableRow?.model_name === "UserProjectPacks") {
									addNewProjectToPack({ rowObj: clickedTableRow });
								} else {
									addNewProject();
								}
							},
						},
						{
							name: "Создать группу",
							icon: <CreateNewFolderOutlinedIcon />,
							size: "large",
							type: "common",
							callback: () => addNewProjectPack(),
						},
					],
				},
				{
					orientation: "vertical",
					_children: [
						{
							name: "Редактировать",
							icon: <EditOutlinedIcon />,
							size: "MEDIUM",
							type: "common",
							isDisabled: clickedTableRow?.id == null,
							callback: () => enableEditingMode(),
						},
						{
							name: "Перейти в проект",
							icon: <ExitToAppOutlinedIcon />,
							size: "MEDIUM",
							type: "common",
							isDisabled: clickedTableRow?.id == null || clickedTableRow?.model_name !== "UserProjects",
							callback: () => enterToProject({ targetId: clickedTableRow?.id }),
						},
						{
							name: "Удалить проект",
							icon: <DeleteOutlinedIcon />,
							size: "MEDIUM",
							type: "common",
							isDisabled: clickedTableRow?.id == null && muiltiClickedTableRows?.length === 0,
							callback: () => showDeleteDialog(),
						},
					],
				},
			],
		},
		{
			name: "Проект",
			_children: [
				{
					name: "Subgroup 1",
					orientation: "vertical",
					styles: { flexDirection: "row", gap: "5px" },
					_children: [
						{
							name: "Импорт",
							icon: <FileUploadOutlinedIcon />,
							size: "large",
							type: "common",
							isDisabled: clickedTableRow?.id == null || clickedTableRow?.model_name !== "UserProjects",
							callback: () => enterToProjectImport(),
							styles: { width: "60px" },
						},
						{
							name: "Свойства",
							isVisible: userPermissions.is_guest !== true,
							icon: <SettingsOutlinedIcon />,
							size: "large",
							type: "common",
							isDisabled: clickedTableRow?.id == null || clickedTableRow?.model_name !== "UserProjects",
							callback: () => {
								dispatch(fetchProject(clickedTableRow?.id)).then((x) => {
									dispatch(setProjectAttrsVisible(true));
								});
							},
							styles: { width: "60px" },
						},
					],
				},
			],
		},
		{
			name: "Редактор",
			_children: [
				{
					orientation: "vertical",
					styles: { flexDirection: "row" },
					_children: [
						{
							name: "Создать смету",
							icon: <NoteAddOutlinedIcon />,
							size: "large",
							type: "common",
							isDisabled:
								userPermissions.is_lsr_editors !== true ||
								clickedTableRow?.id == null ||
								clickedTableRow?.model_name !== "UserProjects",
							callback: () => enterToLsrEditor(),
						},
					],
				},
			],
		},
		{
			name: "Экспорт",
			_children: [
				{
					orientation: "vertical",
					_children: [
						{
							name: "Экспорт протокола",
							icon: <FileOpenOutlinedIcon />,
							size: "MEDIUM",
							type: "common",
							isDisabled: clickedTableRow?.id == null || clickedTableRow?.model_name !== "UserProjects",
							callback: () => getProjectProtocol(),
						},
						{
							name: "Печатная форма",
							icon: <PrintOutlinedIcon />,
							size: "MEDIUM",
							type: "common",
							isDisabled: clickedTableRow?.id == null || clickedTableRow?.model_name !== "UserProjects",
							callback: () => getProjectXlsx(),
						},
						{
							name: "Экспорт в XML",
							icon: <FileDownloadOutlinedIcon />,
							size: "MEDIUM",
							type: "common",
							isDisabled: clickedTableRow?.id == null || clickedTableRow?.model_name !== "UserProjects",
							callback: () => getProjectXmlZip(),
						},
					],
				},
			],
		},
		{
			name: "Вид",
			_children: [
				{
					name: "Subgroup 1",
					orientation: "vertical",
					_children: [
						{
							name: "Свернуть группы",
							icon: <FolderOffOutlinedIcon />,
							size: "MEDIUM",
							type: "common",
							callback: () =>
								dispatch(saveProjectVisible({ projectPackId: "__ALL__", childsVisible: false })).then((x) => {
									getTableData();
								}),
						},
						{
							name: "Развернуть группы",
							icon: <FolderOpenOutlinedIcon />,
							size: "MEDIUM",
							type: "common",
							callback: () =>
								dispatch(saveProjectVisible({ projectPackId: "__ALL__", childsVisible: true })).then((x) => {
									getTableData();
								}),
						},
						{
							name: "Только мои проекты",
							icon: <PersonOutlineOutlinedIcon />,
							size: "MEDIUM",
							type: "common",
							active: onlyMyProject,
							callback: () => dispatch(setOnlyMyProject(!onlyMyProject)),
						},
					],
				},
			],
		},
		{
			name: "Поиск",
			_children: [
				{
					name: "Subgroup 1",
					orientation: "vertical",
					_children: [
						{
							name: "Настройки поиска",
							icon: <ManageSearchIcon />,
							type: "controlled-select-checkbox",
							onChange: ({ keyName, newValue }) => {
								dispatch(setViewParamsKeyValue({ key: keyName, value: newValue }));
								setProjectsViewLsSettings({ key: keyName, value: newValue });
							},
							_children: [
								{
									name: "Всегда отображать содержимое папки",
									value: alwaysShowFolderContent,
									keyName: "alwaysShowFolderContent",
								},
							],
						},
						{
							name: "Расширенный поиск",
							icon: <TroubleshootOutlinedIcon />,
							size: "MEDIUM",
							type: "common",
							active: advSearchVisible,
							callback: () => dispatch(setAdvSearchVisible(!advSearchVisible)),
						},
					],
				},
			],
		},
		{
			name: "Действия",
			isVisible: userPermissions.is_project_share_user === true,
			_children: [
				{
					name: "Subgroup 1",
					orientation: "horizontal",
					_children: [
						{
							name: "Поделиться проектом",
							icon: <ShareOutlinedIcon />,
							size: "large",
							type: "common",
							isVisible: userPermissions.is_project_share_user === true,
							isDisabled:
								clickedTableRow?.id == null ||
								clickedTableRow?.model_name === "UserProjectPacks" ||
								userPermissions.is_project_share_user === false,
							callback: () => dispatch(setShareProjectVisible(true)),
						},
						{
							name: "Отчет по проектам",
							icon: <TableChartOutlinedIcon />,
							size: "large",
							type: "common",
							isVisible: lsrStatusUsage === true,
							isDisabled: userPermissions.is_project_report_user === false,
							callback: () => dispatch(setProjectReportVisible(true)),
						},
					],
				},
			],
		},
	];
};

export default ProjectsRibbonSettings;
